module.exports = __webpack_public_path__ + "static/assets/0e24bd161bdf63fc1cfdc39ba58c0a76.png";